// Funcion para tokenizar una tarjeta con OpenPay
export const tokenizeCard = async (cardData) => {
  return new Promise((resolve, reject) => {
    window.OpenPay.token.create(cardData, response => {
      resolve(response);
    }, error => {
      reject(error);
    });
  });
}

const errorsOpenPay = {
  1001: 'El código de verificación es incorrecto.',
  2001: 'La cuenta de banco con esta CLABE ya se encuentra registrada en el cliente.',
  2002: 'La tarjeta con este número ya se encuentra registrada en el cliente.',
  2003: 'El cliente con este identificador externo (External ID) ya existe.',
  2004: 'El dígito verificador del número de tarjeta es inválido de acuerdo al algoritmo Luhn.',
  2005: 'La fecha de vencimiento de la tarjeta es anterior a la fecha actual.',
  2006: 'El código de seguridad de la tarjeta (CVV2) no fue proporcionado.',
  2007: 'El número de tarjeta es de prueba, solamente puede usarse en Sandbox.',
  2008: 'La tarjeta no es valida para puntos Santander.',
  2009: 'El código de seguridad de la tarjeta (CVV2) es inválido.',
}

export const getTokenizeCardErrorMessage = (errorCode) => {
  return errorsOpenPay?.[errorCode] ?? 'Error al procesar el pago. Por favor, intenta de nuevo.';
}